export default {"src":"/_next/static/media/generic-thumbnail-pdf.613b66e4.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};